import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import ptBR from './locales/pt-br.json'

i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources: {
			'pt-BR': { translation: ptBR },
		},
		fallbackLng: 'pt-BR',
		debug: false,
		detection: {
			order: ['localStorage', 'navigator', 'htmlTag'],
			lookupLocalStorage: 'i18nextLng',
			caches: ['localStorage'],
		},
		interpolation: {
			escapeValue: false,
		},
	})

export default i18n
